import type { DynamicComponentProps } from '@/types/commontypes';
import styles from '../../../styles/global.module.css';
import type { FC } from 'react';

interface FontStyleSelectorProps extends DynamicComponentProps<string> {
  availableStyles: { style: string; label: React.ReactNode }[];
}

const FontStyleSelector: FC<FontStyleSelectorProps> = ({ value, onChange, availableStyles }) => {
  const handleClick = (style: string) => {
    const newStyles = value === style ? '' : style; // Toggle the style if already selected, else set new style
    onChange(newStyles);
  };

  return (
    <div className={`${styles.font_size_select} flex`}>
      {availableStyles.map(({ style, label }) => {
        const isActive = value === style;
        const buttonClasses = `flex items-center justify-center p-0 rounded border text-lg leading-[30px] min-w-8 font-semibold ${isActive ? 'bg-gray-300 text-blue-600' : 'bg-white text-black'} border-gray-400 cursor-pointer`;

        return (
          <button key={style} onClick={() => handleClick(style)} className={buttonClasses}>
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default FontStyleSelector;
